import React, { useEffect, useState } from 'react'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { FieldGroup, FormCard, SubmitButtonMail } from '../../reusable'
import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { SignaturePad } from '../../reusable/sigPad'
import { sectionValidation } from '../../../helpers'
import { browserName, osName } from 'react-device-detect'
import { useClaimData } from '../../../claimProvider'
import Previewer from '../../reusable/previewer'

export const SignatureSentinel = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup, validateSection } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [termsAccepted, setTermsAccepted] = useState(false)
    const [hasSignature, setHasSignature] = useState(false)
    const claim = useClaimData()

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        let tempStepData = stepData
        tempStepData[dataToSave.field] = dataToSave.value
        setStepData(tempStepData)

        if (dataToSave.field === 'acceptTerms') {
            setTermsAccepted(dataToSave.value === 'yes')
        }

        return saved
    }

    const handleSignatureChange = (hasSig: boolean) => {
        setHasSignature(hasSig)
    }

    const handleBack = () => {
        assignGroup('review')
    }

    const animateBeforeAssign = (assignment: string) => {
        console.log(stepData)

        setTimeout(() => {
            assignGroup(assignment)
        }, 400)
    }

    const getCurrentStep = () => {
        console.log('is active:', isActive)
        console.log('claim:', claim)

        const hasSignatureData = claim?.claimData?.sigData?.token

        return isActive === 'signature' && hasSignatureData ? (
            <FieldGroup title="Sign Your CFA & LOA">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                    <Checkbox
                        fieldName={'acceptTerms'}
                        label={
                            'I agree that I have read, understand and accept the Sentinel Legal terms of business and that the check is free. I also agree to instruct Sentinel Legal to send a data subject access request (DSAR) to find out if my PCP or HP agreements were mis-sold.'
                        }
                        saveValue={preSaveValueFunct}
                    />
                    <br />
                    <p style={{ color: 'white' }}>
                        In order for us to progress your claim please sign in the box below agreeing to our terms of
                        business.
                    </p>
                    <SignaturePad
                        extraPayload={{
                            browser: browserName,
                            device: osName,
                            type: claim.leadOrigin,
                            claim,
                        }}
                        additionalAction={() => animateBeforeAssign('complete')}
                        isDisabled={!termsAccepted}
                        onSignatureChange={handleSignatureChange}
                        disclaimer={
                            "*By signing this document, you agree that Sentinel Legal can do a soft credit check to look at your car finance deal, check who you are, and stop money laundering. This check won't affect your credit score, and we will only look at information about your car finance. You also agree that Sentinel Legal can use your signature to complete all claims we find in your name. This will allow us to fill out and send the necessary forms for each claim. Your signature will only be used for claims linked to you, and you can ask us to stop using it at any time. "
                        }
                    />
                    <br />
                    {claim?.claimData?.cfaUrl ? (
                        <Previewer url={claim.claimData.cfaUrl} documentString={'CFA'} />
                    ) : (
                        <></>
                    )}
                    {claim?.claimData?.loaUrl ? (
                        <Previewer url={claim.claimData.loaUrl} documentString={'LOA'} />
                    ) : (
                        <></>
                    )}
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
